/* eslint-disable max-len */
import React from 'react';

const AlignJustifyIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M16.001 16v1H4v-1h12.001zm0-4v1H4v-1h12.001zm0-4v1H4V8h12.001zm0-4v1H4V4h12.001z"
            transform="translate(-417.000000, -149.000000) translate(413.000000, 145.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AlignJustifyIcon;
